import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useHistory, useLocation } from 'react-router-dom'
import _ from 'lodash'
import { toast } from 'react-toastify'
import { TextField, Button, CircularProgress, Typography } from '@mui/material'
import { withStyles } from '@mui/styles'

import { successLogin, changePassword } from 'redux/auth/actions'
import { login } from 'services/apiAuth'
import { gotoUrl, isNetworkError, isUserLogged } from 'utils/functions'
import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import jwtDecode from 'jwt-decode'
import { USER_ROLES } from 'utils/constants/userRoles'

import styles from './styles'

const Login = () => {
  const classes = styles()
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()

  const from = location?.state?.from
  const previousEmail = location?.state?.email

  const accessToken = useSelector((state) => state.auth.access_token)

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (argEmail, argPassword) => {
    setLoading(true)

    const formData = new FormData()
    formData.append('username', argEmail)
    formData.append('password', argPassword)

    await login(formData)
      .then((response) => {
        const { data, status } = response
        if (status === 302) {
          dispatch(
            changePassword({
              email: argEmail,
              changePasswordSession: data.data.session,
            }),
          )

          gotoUrl(ROUTE_CONSTANTS.FORGOT_PASSWORD)
        }

        const userData = data

        if (userData) {
          const currentEmail = jwtDecode(userData.access_token).sub
          dispatch(successLogin({ ...userData }))
          if (from && currentEmail === previousEmail) {
            gotoUrl(from)
          }
        }
      })
      .catch((err) => {
        setLoading(false)
        if (!isNetworkError(err)) {
          const messageError =
            _.get(err, 'response.data.detail') ||
            'Erro ao fazer login'
          toast.error(messageError)
        }
      })
  }

  const onEnterPress = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault()
      return handleSubmit(email, password)
    }
    return false
  }

  useEffect(() => {
    if (isUserLogged(accessToken)) {
      const { role } = jwtDecode(accessToken).extras
      if (role === USER_ROLES.PROSPECT) {
        history.push(ROUTE_CONSTANTS.PROSPECT_DASHBOARD)
      } else {
        history.push(ROUTE_CONSTANTS.HOME)
      }
    }
  }, [accessToken, history])

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        <img
          src="assets/images/logos/client_logo.png"
          alt="Logo"
          className={classes.logo}
        />
      </header>
      <div className={classes.sideTriangle} />
      <aside className={classes.aside}>
        <h1>
          <img
            src="assets/images/logos/client_logo.png"
            alt="Logo"
            className={classes.logo}
          />
        </h1>
        <div className={classes.accessMessage}>
          <h1>Acesso</h1>
          <p>Digite seus dados de acesso à plataforma</p>
        </div>
      </aside>
      <main className={classes.main}>
        <h1 className={classes.title}>Parceiros XP</h1>
        <div className={classes.inputsContainer}>
          <form className={classes.formContainer}>
            <TextField
              variant="standard"
              id="email"
              label="E-mail"
              className={classes.textField}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              required={true}
              autoCorrect="off"
              autoCapitalize="off"
            />
            <TextField
              variant="standard"
              id="password"
              label="Senha"
              className={classes.textField}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={onEnterPress}
              autoComplete="off"
              type="password"
              required={true}
              autoCorrect="off"
              autoCapitalize="off"
            />
          </form>
          <Typography className={classes.link}>
            <Link to={ROUTE_CONSTANTS.FORGOT_PASSWORD}>Esqueci a senha</Link>
          </Typography>
        </div>

        <div className={classes.buttonContainer}>
          <Button
            color="primary"
            variant="contained"
            className={classes.button}
            onClick={() => handleSubmit(email, password)}
            disabled={!!loading}
          >
            {loading ? (
              <CircularProgress className={classes.progress} />
            ) : (
              'Acessar'
            )}
          </Button>
        </div>
      </main>
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(Login)
